import { OpenReviewEntryPresenter } from '@/presentation/presenters/review/openReviewEntryPresenter'
import { OpenReviewEntryViewModel } from '@/presentation/viewmodels/review/openReviewEntryViewModel'

export function useOpenReviewEntryPresenter(
  presenter: OpenReviewEntryPresenter = new OpenReviewEntryPresenter(new OpenReviewEntryViewModel())
) {
  return {
    entryList: presenter.entryList,
    isLoading: presenter.isLoading,
    error: presenter.error,
    hasEntryInList: presenter.hasEntryInList,
    fetchEntryList: presenter.fetchReviewEntryList.bind(presenter)
  }
}
